import {useEffect, useState} from 'react'
import {useGlobalStore} from './useStore'
import { getSecureImageUrl } from '../../utils/image-utils'

export const useProductImage = (img: any) => {
  const {getCustomSitePreferenceById, isCustomSitePreferenceSet, customSitePreferences} =
    useGlobalStore()
  const [imgSrc, setImgSrc] = useState<string>()

  const getImgData = async () => {
    if (img?.dis_base_link || img?.disBaseLink) {
      setImgSrc(getSecureImageUrl(img))
      return
    }
    if (!isCustomSitePreferenceSet('lazyLoadProductImageUrl')) {
      await getCustomSitePreferenceById('lazyLoadProductImageUrl')
    }
    const defaultImage = customSitePreferences['lazyLoadProductImageUrl']
    setImgSrc(`${defaultImage as string}?&fmt=auto`)
  }

  useEffect(() => {
    getImgData()
  }, [customSitePreferences, img])

  return imgSrc
}
